import React, { lazy, memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomo1 = ['Sopas de letras bíblicas', 'Páginas para colorear con historia', 'Reflexiones guiadas paso a paso', 'Ejercicios de comprensión', 'Actividades creativas basadas en relatos bíblicos'];
const tomo2 = ['Juegos grupales con mensaje cristiano', 'Dinámicas de participación activa', 'Actividades rompe-hielo', 'Propuestas para fortalecer la fe jugando'];
const bonos = [{
  num: 1,
  title: '50 Preguntas para Conversar sobre la Fe',
  desc: 'Preguntas listas para generar participación, reflexión y diálogo genuino en el grupo.',
  img: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=200&q=55'
}, {
  num: 2,
  title: 'Kit de Emergencia para Catequistas',
  desc: '5 dinámicas cristianas de 5 minutos para cuando faltan niños, sobra tiempo o el grupo está inquieto.',
  img: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=200&q=55'
}, {
  num: 3,
  title: '30 Oraciones Guiadas para Niños',
  desc: 'Oraciones adaptadas para distintas situaciones cotidianas, listas para usar en cada encuentro.',
  img: 'https://images.unsplash.com/photo-1543165796-5426273eaab3?auto=format&fit=crop&w=200&q=55'
}, {
  num: 4,
  title: 'Calendario de Gratitud Cristiana de 30 Días',
  desc: 'Un desafío para realizar en familia y fortalecer el hábito del agradecimiento desde la fe.',
  img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=200&q=55'
}, {
  num: 5,
  title: 'Certificados de Participación Imprimibles',
  desc: 'Reconocimientos listos para entregar y celebrar el esfuerzo de cada niño al finalizar el año.',
  img: 'https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=200&q=55'
}];
export function Contents() {
  return <section className="py-10 md:py-20 px-4 md:px-6" data-id="element-45">
      <div className="max-w-5xl mx-auto" data-id="element-46">
        {/* Spec Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-md border border-gold-500/20 p-5 md:p-8 mb-10 md:mb-20 text-center" data-id="element-47">
          <h3 className="text-xs md:text-sm font-bold uppercase tracking-widest text-gold-600 mb-2" data-id="element-48">
            El recurso más completo del mercado
          </h3>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-navy-900 mb-6 md:mb-8" data-id="element-49">
            MegaKit de Catequesis Infantil
          </h2>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-50">
            {['+100 recursos', '2 Tomos de actividades', '5 Bonos estratégicos', 'Edades 6 a 12 años', 'PDF imprimible', 'Acceso inmediato', 'Actividades bíblicas', 'Dinámicas grupales', 'Oraciones guiadas', 'Reflexiones', 'Juegos de participación', 'Certificados imprimibles'].map((chip, i) => <span key={i} className="bg-cream-100 text-navy-900 border border-cream-200 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium" data-id="element-51">
                {chip}
              </span>)}
          </div>
        </motion.div>

        <div className="text-center mb-10 md:mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy-900 mb-2 md:mb-4" data-id="element-53">
            Contenido completo
          </h2>
          <p className="text-lg md:text-xl text-navy-900/70" data-id="element-54">
            Los 2 Tomos + 5 Bonos
          </p>
          <p className="text-sm md:text-base text-navy-900/60 mt-1 md:mt-2 px-4" data-id="element-55">
            Todo lo que necesitás para transformar cada encuentro en una
            experiencia memorable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-56">
          {/* Tomo 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -4,
          borderColor: '#c8a24a',
          boxShadow: '0 10px 30px -10px rgba(200,162,74,0.15)'
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-cream-200 cursor-default transition-all" data-id="element-57">
            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-58">
              <span className="text-2xl md:text-3xl" data-id="element-59">📖</span>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-navy-900" data-id="element-60">
                TOMO 1 — Actividades Bíblicas Imprimibles
              </h3>
            </div>
            <ul className="space-y-3 md:space-y-4" data-id="element-61">
              {tomo1.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-62">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold-500 shrink-0" data-id="element-63" />
                  <span className="text-sm md:text-base text-navy-900/80 leading-relaxed" data-id="element-64">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Tomo 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} whileHover={{
          y: -4,
          borderColor: '#c8a24a',
          boxShadow: '0 10px 30px -10px rgba(200,162,74,0.15)'
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-cream-200 cursor-default transition-all" data-id="element-65">
            <div className="flex items-center gap-3 mb-4 md:mb-6" data-id="element-66">
              <span className="text-2xl md:text-3xl" data-id="element-67">🎲</span>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-navy-900" data-id="element-68">
                TOMO 2 — Dinámicas y Juegos para Catequesis
              </h3>
            </div>
            <ul className="space-y-3 md:space-y-4" data-id="element-69">
              {tomo2.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-70">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold-500 shrink-0" data-id="element-71" />
                  <span className="text-sm md:text-base text-navy-900/80 leading-relaxed" data-id="element-72">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Bonos */}
        <div className="mb-8 md:mb-12" data-id="element-73">
          <div className="text-center mb-8 md:mb-10" data-id="element-74">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy-900" data-id="element-75">
              5 Bonos Estratégicos
            </h3>
            <p className="text-sm md:text-base text-gold-600 font-medium mt-1 md:mt-2" data-id="element-76">
              — Incluidos sin costo extra —
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4" data-id="element-77">
            {bonos.map((bono, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.97
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} whileHover={{
            borderColor: 'rgba(200,162,74,0.8)',
            boxShadow: '0 10px 28px -12px rgba(200,162,74,0.35)'
          }} transition={{
            delay: i * 0.07
          }} className="bg-navy-950 text-cream-50 rounded-xl border border-gold-500/30 overflow-hidden group cursor-default flex items-stretch" data-id="element-78">
                <div className="relative w-20 md:w-24 shrink-0 overflow-hidden" data-id="element-79">
                  <img src={bono.img} alt={bono.title} loading="lazy" decoding="async" width={96} height={120} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-80" />
                  <div className="absolute inset-0 bg-navy-950/20" data-id="element-81"></div>
                </div>
                <div className="p-3 md:p-4 flex-1 min-w-0" data-id="element-82">
                  <div className="text-gold-500 font-bold text-[10px] md:text-xs mb-1 tracking-wider" data-id="element-83">
                    🎁 BONO #{bono.num}
                  </div>
                  <h4 className="text-sm md:text-base font-serif font-bold mb-1 leading-tight" data-id="element-84">
                    {bono.title}
                  </h4>
                  <p className="text-cream-50/70 text-[11px] md:text-xs leading-snug" data-id="element-85">
                    {bono.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div whileHover={{
        scale: 1.02
      }} className="bg-gold-500/10 border border-gold-500/30 rounded-xl p-4 md:p-6 text-center transition-transform" data-id="element-86">
          <p className="text-base md:text-xl font-serif font-bold text-navy-900" data-id="element-87">
            Valor total de los bonos:{' '}
            <span className="line-through opacity-60" data-id="element-88">$24.000</span> — incluidos
            completamente <span className="text-gold-600" data-id="element-89">GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}